// extracted by mini-css-extract-plugin
export default {"heading":"fw-z","corrected":"gw-z","redirectVerbiageContainer":"hw-z","redirectVerbiageText":"iw-z"};